import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { HiSearch } from "react-icons/hi";
import style from "./style.module.scss";

import { domain } from "config.js";

import Select from "./Select";

let types = ["loading..."];
let regions = ["loading..."];
let bedrooms = ["loading..."];
let pricelist = ["loading..."];

const optionsTops = {
  type: ["Type"],
  region: ["Regio"],
  location: ["Locatie", "Kies eerst de regio"],
  bedrooms: ["Slaapkamers"],
  from: ["Prijs vanaf"],
  to: ["Prijs tot"],
};

function SearchBar({ className }) {
  const [chosens, setChosens] = useState({});
  const [options, setOptions] = useState(optionsTops);
  const [rawOptions, setRawOptions] = useState(null);

  const history = useHistory();

  useEffect(() => {
    async function getOptions() {
      fetch(domain + "/int-getSearchOptions")
        .then((response) => {
          response.json().then((json) => {
            let ops = { ...optionsTops };
            ops.type = [...ops.type, ...json?.types];

            let region = Object.keys(json?.regions);
            ops.region = [...ops.region, ...region];

            ops.bedrooms = [...ops.bedrooms, ...json?.bedrooms];

            let prices = getPrices(json.prices);
            ops.from = [optionsTops.from[0], ...prices];
            ops.to = [optionsTops.to[0], ...prices];

            setOptions(ops);
            setRawOptions(json);
          });
        })
        .catch((err) => console.log(err));
    }
    getOptions();
  }, []);

  function getPrices(prices) {
    var pric = prices.from;
    var newpricelist = [];

    if (pric !== prices.to) {
      const formatter = new Intl.NumberFormat("en-us", { style: "decimal" });
      const monetize = (mn) => formatter.format(mn) + " €";

      var pricestep = 100000;
      var pricTo = 1000000;

      while (pric + pricestep <= pricTo) {
        newpricelist.push(monetize(pric));
        pric += pricestep;
      }

      pricestep = 1000000;
      pric = 1000000;
      while (pric + pricestep < prices.to) {
        newpricelist.push(monetize(pric));
        pric += pricestep;
      }
      newpricelist.push(monetize(prices.to));
    }

    return newpricelist;
  }

  useEffect(() => {
    console.log("CHOSENS", chosens);
    if (chosens.region) {
      setOptions({
        ...options,
        location: [
          optionsTops.location[0],
          ...rawOptions?.regions[chosens.region],
        ],
      });
    }
    //eslint-disable-next-line
  }, [chosens.region]);

  function startSearch() {
    let params = {};
    params.ref = chosens.ref || "";
    params.type = chosens.type || "";
    params.region = chosens.region || "";
    params.location = chosens.location || "";
    params.bedrooms = chosens.bedrooms || "";
    params.from = chosens.from || "";
    params.to = chosens.to || "";

    history.push("/results?" + new URLSearchParams(params).toString());
  }

  return (
    <div className={style.searchArea + " " + className}>
      <div className={style.title}>VIND UW VASTGOED</div>
      <div className={style.searchFormCnt}>
        <Indicator />
        <div>
          <input
            className={style.refInput}
            placeholder="Referentie"
            onChange={(e) => setChosens({ ...chosens, ref: e.target.value })}
          />
        </div>
        {Object.keys(options).map((key) => {
          return (
            <div key={key}>
              <Select
                options={options[key]}
                locationFirst={options.location[0]}
                param={key}
                chosenState={{ chosens, setChosens }}
              />
            </div>
          );
        })}
        <div className={style.searchButton} onClick={startSearch}>
          <HiSearch size="33" />
        </div>
      </div>
    </div>
  );
}

function Indicator() {
  return (
    <div
      className={style.Indicator}
      style={{
        backgroundImage:
          "url(/Images/infopages/common/searchbar/indicator.png)",
      }}
    >
      <div className={style.text}>
        ZOEK
        <br />
        HIER
      </div>
    </div>
  );
}

export default SearchBar;
